/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function ClientUser(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                height='24'
                width='24'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g>
                    <title>Layer 1</title>
                    <g
                        id='svg_14'
                        stroke='null'
                    >
                        <g
                            id='svg_8'
                            transform='matrix(0.4537916134438105,0,0,0.3941884228137747,-12.852773512868275,-2.964184810292242)'
                        >
                            <path
                                d='m62.323002,40.506011c4.31251,-2.32958 7.38688,-6.55034 8.36691,-11.48903c0.98631,-4.94081 -0.22665,-10.07858 -3.29682,-13.99014c-3.07018,-3.91157 -7.67229,-6.18184 -12.53253,-6.18184c-4.86024,0 -9.46235,2.27027 -12.53043,6.18184c-3.07017,3.91156 -4.28313,9.04933 -3.29892,13.99014c0.98212,4.93869 4.0544,9.15945 8.36691,11.48903c-5.08058,1.65823 -9.51691,4.95987 -12.66893,9.41571c-3.15202,4.45795 -4.85184,9.84138 -4.85394,15.37306c0,0.85135 0.66524,1.55022 1.49207,1.55022c0.82473,0 1.49206,-0.69887 1.49206,-1.55022c0,-8.1641 4.1992,-15.70979 11.00689,-19.7929c6.81398,-4.08099 15.20608,-4.08099 22.01586,0c6.81399,4.08099 11.00898,11.6288 11.00898,19.7929c0,0.85135 0.66734,1.55022 1.49207,1.55022c0.82473,0 1.49207,-0.69887 1.49207,-1.55022c-0.0021,-5.5338 -1.70612,-10.92146 -4.86443,-15.38154c-3.15832,-4.45583 -7.60094,-7.75112 -12.68782,-9.40723m-20.64132,-14.86479c0,-3.62778 1.38714,-7.10732 3.85923,-9.67408c2.47209,-2.56465 5.82347,-4.00687 9.31965,-4.00687c3.49408,0 6.84756,1.44222 9.31965,4.00687c2.47209,2.56676 3.86133,6.04842 3.86133,9.67408c0,3.62778 -1.38924,7.10731 -3.86133,9.67408c-2.47209,2.56464 -5.82557,4.00474 -9.31965,4.00474c-3.49618,-0.00423 -6.84336,-1.44433 -9.31335,-4.0111c-2.47209,-2.56253 -3.86343,-6.03994 -3.86553,-9.66772'
                                fill={iconColor || '#4A4C50'}
                                id='svg_11'
                                mask='url(#mask-2)'
                                stroke='null'
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}